import { GuidanceBox, Heading, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';
import { urlBuilder } from '../../../../Shared/urlBuilder';
import { ForecasterAccountSettingsQuery } from '../../graphql/forecasterAccountSettings.generated';

type Props = { account: NarrowTypename<ForecasterAccountSettingsQuery['account'], 'ManagedAccount'> };

export const AccountPurposeSetupBox = ({ account }: Props) => {
  const { goalId } = account;
  const currentPath = window.location.pathname;

  if (account.envelope.purpose) return null;

  return (
    <GuidanceBox>
      <GuidanceBox.Icon />
      <GuidanceBox.Header>
        <Heading as="h3" variant="title100">
          Have a goal in mind?
        </Heading>
      </GuidanceBox.Header>
      <GuidanceBox.Content css={{ display: 'grid', gap: 'space.100' }}>
        <Text>Add this account to a goal for additional advice on how to save.</Text>
        <SambaAutoLink to={urlBuilder.appGoalsEditPurpose.absolute({ goal_id: goalId, return_to: currentPath })}>
          Add to a goal
        </SambaAutoLink>
      </GuidanceBox.Content>
    </GuidanceBox>
  );
};
